import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';

type Props = {
  /** 타이틀 문구 */
  children: ReactNode;
} & ComponentPropsWithoutRef<'strong'>;

const PopupTitle = forwardRef<HTMLElement, Props>(({ children, ...props }, ref) => {
  return (
    <strong {...props} ref={ref} className="tit_layer">
      {children}
    </strong>
  );
});

PopupTitle.displayName = 'PopupTitle';

export default PopupTitle;
